import { filter, take, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import {
  setOneTrustCookieFromQueryURL
} from 'domain/oneTrust'
import { hasOneTrustQuery } from 'domain/router'

const oneTrustQueryURLEpic = (actions$, _state$) =>
  actions$.pipe(
    ofType(LOCATION_CHANGE),
    filter(hasOneTrustQuery),
    take(1),
    tap(() => { setOneTrustCookieFromQueryURL() })
  )

export default oneTrustQueryURLEpic
